import { MaintenanceBannerTranslations } from "./types";

export const enMaintenanceBannerTranslations: MaintenanceBannerTranslations = {
    upcoming: (starts, ends) =>
        `Scheduled maintenance on ${starts} until ${ends}. You will not be able to log in during this time.`,
    active: (ends) =>
        `Maintenance is happening now. You will not be able to log in until ${ends}.`,
    dismiss: "Dismiss",
};
